export default function isNullOrUndefinied(val) {
  return val === null || val === undefined;
}
